module.exports = __webpack_public_path__ + "media/img/decorations/decoration_right-7b8c2cd9d883a0f999fd839925af57c5.svg";